var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"hover-primary",attrs:{"icon":""},on:{"click":_setup.convertOfferToModelOffer}},on),[_c('v-icon',[_vm._v("mdi-axis-arrow")])],1)]}}])},[_c('span',[_vm._v("Transformer en modèle")])])
}
var staticRenderFns = []

export { render, staticRenderFns }